import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSistema = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: "1000px",
	height: "1000px",
	viewBox: "0 0 1000 1000",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [/* @__PURE__ */ _jsx("title", { children: "Group 10" }), /* @__PURE__ */ _jsx("g", {
		id: "10.-Checker",
		stroke: "none",
		strokeWidth: 1,
		fill: "none",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Group-10",
			children: [/* @__PURE__ */ _jsx("rect", {
				id: "icon_Background",
				x: 0,
				y: 0,
				width: 1e3,
				height: 1e3
			}), /* @__PURE__ */ _jsxs("g", {
				id: "graffa-complessa",
				transform: "translate(247.222222, 101.333333)",
				children: [
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-12",
						stroke: "#0056C1",
						strokeWidth: 28,
						x: 294.555556,
						y: 107.111111,
						width: 194.222222,
						height: 194.222222
					}),
					/* @__PURE__ */ _jsx("rect", {
						id: "Rectangle-Copy-13",
						stroke: "#0056C1",
						strokeWidth: 28,
						x: 294.555556,
						y: 496,
						width: 110.888889,
						height: 194.222222
					}),
					/* @__PURE__ */ _jsx("path", {
						d: "M219.333333,799.111111 L219.333333,759.111111 L131.333333,759.111111 L131.333333,512 C131.333333,483.555556 123.481481,459.703704 107.777778,440.444444 C92.0740741,421.185185 71.4814815,410.074074 46,407.111111 L46,407.111111 L46,392.888889 C71.4814815,389.925926 92.0740741,378.814815 107.777778,359.555556 C123.481481,340.296296 131.333333,316.444444 131.333333,288 L131.333333,288 L131.333333,40.8888889 L219.333333,40.8888889 L219.333333,0.888888889 L139.333333,0.888888889 C122.148148,0.888888889 109.111111,5.92592593 100.222222,16 C91.3333333,26.0740741 86.8888889,38.8148148 86.8888889,54.2222222 L86.8888889,54.2222222 L86.8888889,293.333333 C86.8888889,319.407407 79.037037,338.814815 63.3333333,351.555556 C47.6296296,364.296296 26.7407407,370.666667 0.666666667,370.666667 L0.666666667,370.666667 L0.666666667,429.333333 C26.7407407,429.333333 47.6296296,435.703704 63.3333333,448.444444 C79.037037,461.185185 86.8888889,480.592593 86.8888889,506.666667 L86.8888889,506.666667 L86.8888889,745.777778 C86.8888889,761.185185 91.3333333,773.925926 100.222222,784 C109.111111,794.074074 122.148148,799.111111 139.333333,799.111111 L139.333333,799.111111 L219.333333,799.111111 Z",
						id: "{",
						fill: "#424548",
						fillRule: "nonzero"
					})
				]
			})]
		})
	})]
});
export default SvgSistema;
